import React from 'react';
import { Link } from 'react-router-dom';

function ArticleCard({ article, compact = false, horizontal = false }) {
  return (
    <article className={`article-card ${compact ? 'compact' : ''} ${horizontal ? 'horizontal' : ''}`}>
      <Link className="card-image" to={`/article/${article.slug}`}>
        <img src={article.image} alt="" loading="lazy" />
      </Link>
      <div className="card-content">
        <div className="story-kicker">{article.category} <span>{article.label}</span></div>
        <h3><Link to={`/article/${article.slug}`}>{article.title}</Link></h3>
        {!compact && <p>{article.excerpt}</p>}
        <div className="story-meta">
          <span>{article.date}</span><i>•</i><span>{article.readTime}</span>
        </div>
        {!compact && <div className="story-source">Source: <b>{article.source}</b></div>}
      </div>
    </article>
  );
}

export default ArticleCard;